import * as React from "react";
import classNames from "classnames";

import ArrowLink from "../arrow-link/arrow-link";

export interface ITitleLinkTopProps {
    className?: string;
    title?: string;
    viewMoreLink?: string;
}

const TitleLinkTop = ({ className, title, viewMoreLink }: ITitleLinkTopProps) => {
    const baseClass = "title-link-top";
    const componentClasses = classNames(baseClass, className);

    const headerTitle = title && (
        <h2 className={`${baseClass}__title h2-style`} dangerouslySetInnerHTML={{ __html: title }} />
    );
    const headerLink = viewMoreLink && <ArrowLink className={`${baseClass}__link`} link={viewMoreLink} />;

    return (
        <div className={componentClasses}>
            {(headerTitle || headerLink) && (
                <div className={`${baseClass}__inner`}>
                    {headerTitle}
                    {headerLink}
                </div>
            )}
        </div>
    );
};

export default TitleLinkTop;
